import React from "react";
import { motion } from "framer-motion";
import { Button, Chip, useTheme } from "@mui/material";
import { FiMapPin, FiUser, FiCalendar } from "react-icons/fi";

const InviteCard = ({ invite, onAccept, onDecline, sent }) => {
  const { organizationName, eventName, location, status } = invite;

  const getStatusStyle = (status) => {
    switch (status.toLowerCase()) {
      case "upcoming":
        return {
          label: "Upcoming",
          color: "#6a1b9a",
          bg: "rgba(106, 27, 154, 0.15)",
        };
      case "declined":
        return {
          label: "Declined",
          color: "#d32f2f",
          bg: "rgba(211, 47, 47, 0.1)",
        };
      case "pending":
        return {
          label: "Pending",
          color: "#37474f",
          bg: "rgba(128, 128, 128, 0.1)",
        };
      case "accepted":
        return {
          label: "Accepted",
          color: "#2e7d32",
          bg: "rgba(46, 125, 50, 0.15)",
        };
      default:
        return { label: "Unknown", color: "grey", bg: "rgba(128,128,128,0.1)" };
    }
  };

  const { label, color, bg } = getStatusStyle(status);

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      style={{
        marginBottom: "10px",
        padding: "20px",
        borderRadius: "18px",
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(12px)",
        boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
        border: "1px solid rgba(255, 255, 255, 0.25)",
      }}
    >
      <h3
        style={{
          fontSize: "18px",
          fontWeight: "600",
          color: "#1a237e",
          marginBottom: 6,
        }}
      >
        {eventName}
      </h3>

      <div
        style={{
          fontSize: "14px",
          color: "#555",
          marginBottom: 8,
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <FiUser /> {organizationName}
      </div>

      <div
        style={{
          fontSize: "14px",
          color: "#555",
          marginBottom: 8,
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <FiMapPin /> {location}
      </div>

      <div
        style={{
          fontSize: "14px",
          color: "#555",
          marginBottom: 12,
          display: "flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        <FiCalendar /> Status:
        <Chip
          label={label}
          size="small"
          style={{
            backgroundColor: bg,
            color,
            fontWeight: 600,
            marginLeft: 4,
            borderRadius: 6,
            padding: "0 6px",
          }}
        />
      </div>

      {status.toLowerCase() === "pending" && sent === false && (
        <div style={{ display: "flex", gap: "12px", marginTop: "10px" }}>
          <Button
            fullWidth
            variant="contained"
            size="small"
            color="primary"
            style={{
              borderRadius: 10,
              textTransform: "none",
              fontWeight: 600,
            }}
            onClick={() =>
              onAccept(invite.invitationId, invite.eventId, invite)
            }
          >
            Accept
          </Button>
          <Button
            fullWidth
            variant="outlined"
            size="small"
            color="error"
            style={{
              borderRadius: 10,
              textTransform: "none",
              fontWeight: 600,
            }}
            onClick={() => onDecline(invite.invitationId)}
          >
            Decline
          </Button>
        </div>
      )}
    </motion.div>
  );
};

export default InviteCard;
